import React from 'react';
import { Nav } from 'react-bootstrap';

const ProductsSubMenu = ({ activeTab, onTabChange }) => {
    return (
        <div className="mb-4">
            {/* Flow Diagram */}
            <div className="d-flex justify-content-center align-items-center mb-3">
                <div className="d-flex align-items-center">
                    {/* Shopify Box */}
                    <div
                        className={`px-4 py-3 border rounded text-center ${activeTab === 'shopify'
                                ? 'bg-primary text-white border-primary'
                                : 'bg-light text-dark border-secondary'
                            }`}
                        style={{
                            minWidth: '120px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => onTabChange('shopify')}
                    >
                        <strong>Shopify</strong>
                    </div>

                    {/* Arrow */}
                    <div className="mx-4" style={{ fontSize: '24px', color: '#6c757d' }}>
                        →
                    </div>

                    {/* MELI Box */}
                    <div
                        className={`px-4 py-3 border rounded text-center ${activeTab === 'meli'
                                ? 'bg-success text-white border-success'
                                : 'bg-light text-dark border-secondary'
                            }`}
                        style={{
                            minWidth: '120px',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease'
                        }}
                        onClick={() => onTabChange('meli')}
                    >
                        <strong>MELI</strong>
                    </div>
                </div>
            </div>

            {/* Tabs Menu */}
            <Nav variant="tabs">
                <Nav.Item>
                    <Nav.Link
                        eventKey="shopify"
                        active={activeTab === 'shopify'}
                        onClick={() => onTabChange('shopify')}
                        className={activeTab === 'shopify' ? 'fw-bold' : ''}
                    >
                        Shopify
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link
                        eventKey="meli"
                        active={activeTab === 'meli'}
                        onClick={() => onTabChange('meli')}
                        className={activeTab === 'meli' ? 'fw-bold' : ''}
                    >
                        MELI
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </div>
    );
};

export default ProductsSubMenu;
